var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-box" },
    [
      _vm.tabsName === "personnelChange"
        ? _c(
            "el-timeline",
            [
              _vm.list.length == 0
                ? _c("div", { staticClass: "default" }, [
                    _c("img", {
                      staticClass: "img",
                      attrs: {
                        src: require("../../../../assets/images/emptyState.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _vm._v("暂无人事异动数据~"),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.list, function (item, index) {
                return _c("el-timeline-item", { key: index }, [
                  item.types === 3
                    ? _c("div", { staticClass: "quit" }, [
                        _c(
                          "div",
                          { staticClass: "time" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  item.date ? item.date : item.created_at
                                ) +
                                " "
                            ),
                            _c(
                              "el-tag",
                              {
                                staticClass: "ml15",
                                attrs: { type: "warning", size: "mini" },
                              },
                              [_vm._v("离职")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "离职时部门： " +
                              _vm._s(item.o_frame ? item.o_frame.name : "")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "离职时职位：" +
                              _vm._s(
                                item.o_position ? item.o_position.name : ""
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v("离职原因： " + _vm._s(item.info))]),
                        _vm._v(" "),
                        _c("div", [_vm._v("离职备注： " + _vm._s(item.mark))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.types === 1
                    ? _c("div", { staticClass: "quit" }, [
                        _c(
                          "div",
                          { staticClass: "time" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  item.date ? item.date : item.created_at
                                ) +
                                "\n          "
                            ),
                            _c(
                              "el-tag",
                              {
                                staticClass: "ml15",
                                attrs: { type: "warning", size: "mini" },
                              },
                              [_vm._v("转正")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("转正备注： " + _vm._s(item.mark || "--")),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.types === 2
                    ? _c("div", { staticClass: "post-transfer quit" }, [
                        _c(
                          "div",
                          { staticClass: "time" },
                          [
                            _vm._v(_vm._s(item.created_at) + " "),
                            _c(
                              "el-tag",
                              {
                                staticClass: "ml15",
                                attrs: { type: "success", size: "mini" },
                              },
                              [_vm._v("调岗")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [_vm._v("新部门职位： 产品研发部")]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("原部门职位： 研发工程师；p8，职等3"),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "调岗备注： 由于特殊原因进行调岗操作，已经得到上级领导批准"
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.types === 0
                    ? _c("div", { staticClass: "post-transfer quit" }, [
                        _c(
                          "div",
                          { staticClass: "time" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  item.date ? item.date : item.created_at
                                ) +
                                " "
                            ),
                            _c(
                              "el-tag",
                              { staticClass: "ml15", attrs: { size: "mini" } },
                              [_vm._v("入职")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("员工类型： " + _vm._s(item.is_part || "--")),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "入职时部门：" +
                              _vm._s(item.n_frame ? item.n_frame.name : "--")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "职位： " +
                              _vm._s(
                                item.n_position ? item.n_position.name : "--"
                              )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabsName == "salaryAdjustmentRecord"
        ? _c(
            "el-timeline",
            [
              _vm.list.length == 0
                ? _c("div", { staticClass: "default" }, [
                    _c("img", {
                      staticClass: "img",
                      attrs: {
                        src: require("../../../../assets/images/emptyState.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _vm._v("暂无调薪数据~"),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.list, function (activity, index) {
                return _c(
                  "el-timeline-item",
                  {
                    key: index,
                    attrs: {
                      icon: activity.icon,
                      type: activity.type,
                      color: activity.color,
                      size: activity.size,
                    },
                  },
                  [
                    _c("div", { staticClass: "quit" }, [
                      _c(
                        "div",
                        { staticClass: "time" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(activity.take_date) +
                              "\n          "
                          ),
                          index + 1 !== _vm.list.length
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "ml15",
                                  attrs: { type: "success", size: "mini" },
                                },
                                [_vm._v("调薪")]
                              )
                            : _c(
                                "el-tag",
                                {
                                  staticClass: "ml15",
                                  attrs: { size: "mini" },
                                },
                                [_vm._v("定薪")]
                              ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "icon" }),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v("薪资合计(元)： " + _vm._s(activity.total)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "salary" },
                        _vm._l(activity.content, function (item, id) {
                          return _c("span", { key: id }, [
                            _vm._v(
                              _vm._s(item.label) + "   " + _vm._s(item.value)
                            ),
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v("操作日期： " + _vm._s(activity.created_at)),
                      ]),
                    ]),
                  ]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }